<template>
<div>
    <div class="mb-5">
        <base-button white class="ml-3" @click="showFilters = true">{{$t('filterAppointments')}}</base-button>
    </div>
    <div class="appointments-container">
        <div>
            <div>
                <h4>{{$t('pastAppointmentsTitle')}}</h4>
            </div>
            <div class="m-4" v-if="!pastAppointmentsData.length">
                <h5 v-html="$t('emptypastAppointments')"></h5>
            </div>
            <div class="my-4" v-else>
                <appointment-row-patient v-for="item in pastAppointmentsData" :key="item.appointmentId" :id="item.appointmentId" :serviceType="item.consultancyType" :profPage="item.customPageUrl" :profName="item.doctorName" :patientName="item.patientName" :petName="item.petName" :changeUserEnabled="item.loggedPatientId !== item.patientId" 
                :patientId="item.patientId" :date="item.date" :stateTitle="getPastAppointmentsStateTitle(item)" :actionButtons="getPastAppointmentsActionButtons(item)" :profSearchDisabled="item.searchDisabled" :historyShared="item.historyShared" :profPhoto="item.profPhoto"></appointment-row-patient>
            </div>
        </div>
    </div>
    <appointments-filters v-model="showFilters" @filter="loadAppointments($event)"></appointments-filters>
    <payment-modal v-model="showPaymentModal" :paymentType="payment.paymentType" :price="payment.price" :appointmentId="payment.appointmentId" :ePrescriptionAvailable="payment.ePrescriptionAvailable" :copayment="payment.copayment" @loadAppointments="loadAppointments()" @closePaymentModal="showPaymentModal = false"></payment-modal>
    <arrow-up></arrow-up>
</div>
</template>

<script>
import AppointmentsFilters from '@/components/webapp/patient/appointments/AppointmentsFilters'
import AppointmentRowPatient from '@/components/shared/AppointmentRowPatient'
import appointmentsRepository from '@/repositories/AppointmentsRepository'
import appointmentsMixin from '@/mixins/appointments.mixin'
import BaseDialog from '@/components/base/BaseDialog'
import PaymentModal from '@/components/payment/PaymentModal'
import {
	CLOSED,
	CANCELLED_PATIENT,
	CANCELLED_PROF,
	EXPIRED,
	getPastStatesTitle
} from '@/constants/db/consultationStates'
import {
	CHAT
} from '@/constants/consultationTypes'
import ArrowUp from '@/components/shared/ArrowUp'
import i18nMixin from '@/mixins/i18n.mixin'
import {
	utcDateToUtcFormat
} from '@/helpers/date.helpers'
import {
	inMx
} from '@/helpers/global.helpers'

const MENTTUM_CODE = 'MENTTUM_API_USER_CODE'
const INTERVAL_REFRESH_APPOINTMENTS = 300000
const I18N_PAYMENTS_FILE = 'payments'

export default {
	components: {
		AppointmentRowPatient,
		AppointmentsFilters,
		PaymentModal,
		BaseDialog,
		ArrowUp
	},
	mixins: [appointmentsMixin, i18nMixin(I18N_PAYMENTS_FILE)],
	data () {
		return {
			payment: {
				price: null,
				paymentType: null,
				appointmentId: null,
				ePrescriptionAvailable: null,
				copayment: null
			},
			showFilters: false,
			showPaymentModal: false,
			pastAppointmentsData: [],
			refreshAppointmentsInterval: null
		}
	},
	props: {
		filters: {
			type: Object,
			required: false,
			default: {}
		}
	},
	created () {
		window.history.replaceState(null, '', window.location.pathname)
		this.loadAppointments(this.filters)
	},
	mounted () {
		this.refreshAppointmentsInterval = setInterval(() => {
			this.loadAppointments(this.filters)
		}, INTERVAL_REFRESH_APPOINTMENTS)
	},
	destroyed () {
		clearInterval(this.refreshAppointmentsInterval)
	},
	methods: {
		loadAppointments (filters = {}) {
			appointmentsRepository.getPastPatientAppointments(filters).then(response => {
				if (response.data.data) {
					this.pastAppointmentsData = response.data.data.map(item => {
						item.customPageUrl = this.$store.state.session.user.companyCode && this.$store.state.session.user.companyCode.code === MENTTUM_CODE ? this.$helpers.getMenttumUrl() : this.$helpers.getCustomPageUrl(item.customPageUrl)
						item.date = utcDateToUtcFormat(item.date)
						return item
					})
				} else {
					this.resetData()
				}
			})
		},
		getPastChatsAppointmentsStateTitle (item) {
			return item.appointmentState === EXPIRED ? this.$t('appointmentStates.expired') : item.appointmentState === CANCELLED_PATIENT ? this.$t('appointmentStates.cancelledPatient') : item.appointmentState === CANCELLED_PROF ? this.$t('appointmentStates.cancelledProfessional') : item.appointmentState === CLOSED && item.prescribed ? this.$t('appointmentStates.finishedWithPrescription') : this.$t('appointmentStates.finished')
		},
		getPastAppointmentsStateTitle (item) {
			if (item.consultancyType === CHAT) {
				return this.getPastChatsAppointmentsStateTitle(item)
			} else {
				if (getPastStatesTitle(item.appointmentState)) {
					return getPastStatesTitle(item.appointmentState)
				} else if (!item.reported) {
					return this.$t('appointmentStates.stillNoReported')
				}
			}
		},
		getCommonActionButtons (item) {
			let actions = []
			if (item.priceVisible && item.billed) actions.push(this.invoiceAction(item))
			if (inMx && item.prescribed) actions.push(this.prescriptionAction(item))
			if (item.reviewed) actions.push(this.reviewAction(item))
			if (item.errorPayment) actions.push(this.paymentErrorAction(item))
			return actions
		},
		getPastChatsActionButtons (item) {
			let actions = []
			if (item.loggedPatientId !== item.patientId) return actions
			if (item.appointmentState !== EXPIRED && item.appointmentState !== CANCELLED_PATIENT && item.appointmentState !== CANCELLED_PROF) {
				actions = actions.concat(this.getCommonActionButtons(item))
				if (typeof item.doctorName !== 'undefined' && item.doctorName) actions.push(this.showChatAction(item))
			}
			return actions
		},
		getPastAppointmentsActionButtons (item) {
			let actions = []
			if (item.loggedPatientId !== item.patientId) return actions
			if (item.consultancyType === CHAT) {
				return this.getPastChatsActionButtons(item)
			} else {
				actions = actions.concat(this.getCommonActionButtons(item))
				if (item.reported) actions.push(this.reportAction(item))
				if (item.closedWithoutReport || item.attendedOutside) actions.push(this.showAppointmentAction(item, true))
				return actions
			}
		},
		resetData () {
			this.pastAppointmentsData = []
		}
	},
	computed: {}
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/appointments/PastAppointments.vue